import { render, staticRenderFns } from "./Playvideos.vue?vue&type=template&id=e4544ef6"
import script from "./Playvideos.vue?vue&type=script&lang=js"
export * from "./Playvideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports